const translations = {
    en: {
        home: {
            welcome: "Welcome",
            description: "This is a starter app"
        }
    },
    sv: {
        home: {
            welcome: "Välkommen",
            description: "Detta är en startapp"
        }
    }
};

export default translations;
